import { Translate } from "components/common/Translate/Translate";
import { useDownloadButton } from "../../ControlBar/DownloadButton/useDownloadButton";

export const MobileAction = () => {
    const { handleClick, isDownloading } = useDownloadButton();
    return (
        <button
            className={`flex items-center gap-2 px-4 py-3 rounded-xl text-white ${
                isDownloading ? "bg-irGray-200" : "bg-irBlue-200"
            } text-sm`}
            onClick={handleClick}
        >
            <span className="capitalize">
                <Translate keyName="download" />
            </span>
        </button>
    );
};
